import { render, staticRenderFns } from "./ZinusWorldTimeWebpart.vue?vue&type=template&id=555643c9"
import script from "./ZinusWorldTimeWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ZinusWorldTimeWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports